import { Box, Skeleton } from '@factorialco/deprecated-design-system'

export const MeetingsNavigationSkeleton = () => {
  return (
    <Box height="full" width="full" alignItems="center">
      <Box width="full" flexDirection="row" paddingTop="s20" paddingX="s16" paddingBottom="s8">
        <Skeleton isLoading height="s20" width="s120" />
      </Box>
      <Box width="full" flexDirection="column" paddingX="s16" paddingBottom="s8" gap="s8">
        <Skeleton isLoading height="s32" />
        <Skeleton isLoading height="s32" width="s140" />
        <Skeleton isLoading height="s32" width="s200" />
        <Skeleton isLoading height="s32" width="s140" />
        <Skeleton isLoading height="s32" width="s120" />
      </Box>
    </Box>
  )
}
